import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import { TextArea } from 'common-src/components/base';
import {
  WellnessPlanDataByField,
  WellnessPlanFormFields,
} from 'common-src/models/PatientWellnessPlan';

import commonStyles from 'src/pages/DocumentationIndex/commonStyles.module.scss';

import styles from './WellnessPlanModule.module.scss';

const WellnessPlanModule = ({
  wellnessPlan,
  setWellnessPlan,
  setHasDetectedChanges,
  meta,
  classNames = [],
}) => {
  const hasCustomVisibleFields = Boolean(meta?.visibleFields?.length);
  const visibleFields = hasCustomVisibleFields ? meta.visibleFields : WellnessPlanFormFields;

  const onTextChange = (field, value) => {
    setWellnessPlan((prev) => ({ ...prev, [field]: value }));
    setHasDetectedChanges(new Date());
  };

  return (
    <div className={[styles.container, 'flex-column', 'gap-14', ...classNames].join(' ')}>
      <span className={['font-w-600', 'font-s-16'].join(' ')}>Wellness Plan</span>
      {!hasCustomVisibleFields && (
        <span className={['font-w-500', 'font-s-14'].join(' ')}>
          When creating a wellness plan, write in first person (“I” or “My”). Note that a wellness
          plan may remain the same from previous visits or you may update as appropriate.
        </span>
      )}
      {visibleFields.map((field) => {
        const camelCaseField = _.camelCase(field);
        const data = WellnessPlanDataByField[camelCaseField];
        if (!data) return null;

        const { label, description } = data;
        return (
          <TextArea
            key={camelCaseField}
            id={label.toLowerCase()}
            classNames={['m-b-16']}
            inputClassNames={[commonStyles.inputText]}
            onTextChange={(newValue) => onTextChange(camelCaseField, newValue)}
            value={wellnessPlan[camelCaseField] ?? ''}
            label={label}
            placeholder={`Enter ${label}`}
            description={description}
            maxRows={20}
            size="small"
            withError={false}
          />
        );
      })}
    </div>
  );
};

WellnessPlanModule.propTypes = {
  wellnessPlan: PropTypes.object,
  setWellnessPlan: PropTypes.func,
  setHasDetectedChanges: PropTypes.func,
  meta: PropTypes.object,
  classNames: PropTypes.arrayOf(PropTypes.string),
};

export default WellnessPlanModule;
